import {createStore, applyMiddleware } from "redux"
import thunk from "redux-thunk"
import { Reducers } from "./CombinedReducers"

export const Store = createStore(
  Reducers,
  {},
  applyMiddleware(thunk)
)